var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-scrollbar",style:(_vm.style),on:{"scroll":_vm.onScroll}},[_c('div',{staticClass:"fm-scrollbar-wrap",style:(_vm.wrapStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }